const blogPosts = [
  {
    slug: 'seasonal-lawn-care-schedule',
    title: 'Seasonal Lawn Care Schedule for Farmington Valley',
    excerpt: 'Break down your lawn care to-do list by season and keep every acre of Farmington Valley turf lush, weed-free, and party ready.',
    publishDate: 'January 22, 2025',
    readingTime: '6 min',
    heroOverline: 'Seasonal Strategy'
  },
  {
    slug: 'core-aeration-benefits',
    title: 'Why Core Aeration Matters for Connecticut Lawns',
    excerpt: 'Compacted soils choke roots and invite weeds. Learn when and why Connecticut lawns crave annual core aeration.',
    publishDate: 'January 22, 2025',
    readingTime: '5 min',
    heroOverline: 'Turf Science'
  },
  {
    slug: 'fall-cleanup-checklist',
    title: 'The Ultimate Fall Cleanup Checklist for Hartford County',
    excerpt: 'Leaf piles, clogged gutters, and messy beds compromise winter health. Follow this checklist for a spotless yard.',
    publishDate: 'January 22, 2025',
    readingTime: '7 min',
    heroOverline: 'Seasonal Prep'
  },
  {
    slug: 'winterize-irrigation-systems',
    title: 'How to Winterize Your Irrigation System Before the First Freeze',
    excerpt: 'Frozen irrigation lines are pricey to fix. Use this step-by-step approach before Connecticut temperatures plunge.',
    publishDate: 'January 22, 2025',
    readingTime: '6 min',
    heroOverline: 'Irrigation Insight'
  },
  {
    slug: 'mulch-edging-curb-appeal',
    title: 'Mulch, Edging, and Curb Appeal Tricks That Last All Season',
    excerpt: 'Crisp landscape beds elevate any property. Discover color, depth, and edging combos the pros rely on.',
    publishDate: 'January 22, 2025',
    readingTime: '5 min',
    heroOverline: 'Curb Appeal'
  },
  {
    slug: 'drought-resistant-landscaping-ideas',
    title: 'Drought-Resistant Landscaping Ideas for Connecticut Summers',
    excerpt: 'Beat watering bans and keep color popping with hardy plants, smart irrigation, and soil strategies.',
    publishDate: 'January 22, 2025',
    readingTime: '6 min',
    heroOverline: 'Smart Planting'
  },
  {
    slug: 'snow-readiness-commercial-lots',
    title: 'Snow Readiness Guide for Commercial Parking Lots',
    excerpt: 'Property managers can avoid costly shutdowns by prepping lots, signage, and communication plans now.',
    publishDate: 'January 22, 2025',
    readingTime: '6 min',
    heroOverline: 'Winter Operations'
  },
  {
    slug: 'hedge-trimming-secrets',
    title: 'Hedge & Shrub Trimming Secrets from the Pros',
    excerpt: 'Consistent routines, sharp blades, and growth-cycle awareness keep hedges dense and elegant.',
    publishDate: 'January 22, 2025',
    readingTime: '5 min',
    heroOverline: 'Plant Health'
  },
  {
    slug: 'hoa-grounds-management',
    title: 'Year-Round Grounds Management Tips for HOAs',
    excerpt: 'From budgeting to seasonal scopes, see how leading HOAs keep communities pristine without the stress.',
    publishDate: 'January 22, 2025',
    readingTime: '7 min',
    heroOverline: 'Community Care'
  },
  {
    slug: 'sustainable-landscaping-connecticut',
    title: 'Sustainable Landscaping Trends Taking Root in Connecticut',
    excerpt: 'Pollinator beds, smart irrigation, and battery-powered equipment are reshaping Connecticut landscapes.',
    publishDate: 'January 22, 2025',
    readingTime: '6 min',
    heroOverline: 'Sustainability'
  }
];

export default blogPosts;
